module.exports = __webpack_public_path__ + "static/media/logo-bicolor.fb421124.png";